import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-abd8888e"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "rednote-new-info"
};
const _hoisted_3 = {
  class: "tit"
};
const _hoisted_4 = {
  key: 0,
  class: "is_join"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "rednote-new-box",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goDrawInfo && $options.goDrawInfo(...args))
  }, [_createElementVNode("img", {
    class: "rednote-new-img",
    src: $options.imgUrlFilter($props.rednoteInfo.img, 187 * $data.radio)
  }, null, 8, _hoisted_1), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($props.rednoteInfo.title), 1)]), $props.rednoteInfo.is_join ? (_openBlock(), _createElementBlock("div", _hoisted_4)) : _createCommentVNode("", true)]);
}